// extracted by mini-css-extract-plugin
export default {"image":"image__ngoC3","image__view":"image__view__lxJ3L"};